import React, { useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function RoleManagerFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();

  

  const validateForm = () => {
    const rolename = document.getElementById("rolename").value.trim();
    let newErrors = {};

    if (!rolename) {
      newErrors.rolename = "Role name is required.";
    } else if (rolename.length < 3) {
      newErrors.rolename = "Role name must be at least 3 characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const rolename = document.getElementById("rolename").value.trim();

    const formData = new FormData();
    formData.append("rolename", rolename);
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid); // replace with logged-in user
    formData.append("id", userData?.id || "");

    try {
      const response = await fetch("https://pro.mokshiq.in/role_manager_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
        return;
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
         if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Role" : "Add Role"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="form-validation">
          {/* Role Name */}
          <div className="col-md-12">
            <label className="form-label" htmlFor="rolename">Role Name</label>
            <input
              className={`form-control ${errors.rolename ? "is-invalid" : ""}`}
              id="rolename"
              name="rolename"
              type="text"
              defaultValue={userData?.Name || ""}
            />
            {errors.rolename && <div className="text-danger mt-1">{errors.rolename}</div>}
          </div>
        </form>
      </div>
    </BaseModal>
  );
}
